import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  siteName: "Kore Wellbeing",
  baseUrl: "https://korewellbeing.com",
  defaultImage: "https://korewellbeing.com/brand/kore-og.jpg",
  twitter: "@korewellbeing",
  locale: "en_GB",
};

export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const url = `${DEFAULTS.baseUrl}${path}`;
  const fullTitle = title
    ? `${title} · ${DEFAULTS.siteName}`
    : `${DEFAULTS.siteName} — Train Well. Live Better.`;
  const desc =
    description ||
    "The gym for people 40+ who want to get fit, stay fit and enjoy doing it. Group coaching, independent gym membership and studio hire in Bowness-on-Windermere, Cumbria.";
  const img = image || DEFAULTS.defaultImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:locale" content={DEFAULTS.locale} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
